import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Field,
  reduxForm,
  stopSubmit,
  getFormValues,
  FieldArray,
} from 'redux-form';
import {
  Form,
  FormGroup,
  Label,
  Alert,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalBody,
} from 'reactstrap';

import TextInput from '../../system/fields/TextInput';
import SelectDropdown from '../../system/fields/SelectDropdown';
import FileUpload from '../../system/fields/FileUpload';
import AddressSearch from '../../system/fields/AddressSearch';
import Wysiwyg from '../../system/fields/Wysiwyg';
import List from '../../system/fields/List';
import StarRating from "../../system/fields/StarRating";

import * as validations from '../../system/utils/Validation';

import { getOverview } from '../../store/overview';
import ReviewsTable from '../Deals/components/ReviewsTable';
import Activites from './components/Activites';
import Faq from './components/Faq';
import DealNewCruiseLineWrapper from '../Deals/components/DealNewCruiseLineWrapper';
import { getBoardTypes, getFacilities, getRoomTypes } from '../../store/overview';
import CreatableSelect from "../../system/fields/CreatableSelect";

class EditForm extends Component {
  constructor() {
    super();

    this.toggleCruiseLine = this.toggleCruiseLine.bind(this);
  }
  state = {
    activeTab: 1,
    cruiseLineToggle: false,
  };

  toggleCruiseLine() {
    this.setState({
      cruiseLineToggle: !this.state.cruiseLineToggle,
    });
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  componentDidMount() {
    this.props.dispatch(getOverview());
    this.props.dispatch(getBoardTypes());
    this.props.dispatch(getFacilities());
    this.props.dispatch(getRoomTypes());
  }

  render() {
    const { props } = this;
    const { handleSubmit, mode, regions } = this.props;
    const blob = '<iframe class="widgety-ship-iframe" frameborder="0" height="600" src="//www.widgety.co.uk/widgets/7RJzLf4F78x-F_dHmB2G.widget" width="100%"></iframe>'
    

    return (
      <section className='edit-form'>
        <Form onSubmit={handleSubmit}>
            <section className="form-section">
                <div className="row">
                    <FormGroup className="col-12 col-sm-4">
                        <Label>Ship Name</Label>
                        <Field
                             name='name'
                             placeholder='Enter Ship Name'
                             component={TextInput}
                             type='text'
                             validate={validations.required}
                        />
                    </FormGroup>
                    <FormGroup className='col-12 col-sm-4'>
                        <Label>Cruise Line Name</Label>
                        <Field
                        name='cruise_line'
                        component={SelectDropdown}
                        options={this.props.cruiseLines}
                        labelKey={'value'}
                        valueKey={'id'}
                        type='text'
                        multi={false}
                        className='form-control'
                        validate={validations.required}
                        />
                            <Modal
                            isOpen={this.state.cruiseLineToggle}
                            toggle={this.toggleCruiseLine}
                            >
                                <ModalBody>
                                    <DealNewCruiseLineWrapper regions={regions} />
                                </ModalBody>
                            </Modal>
                    </FormGroup>
                    <FormGroup className="col-12 col-sm-4">
                        <Label>Ship Rating</Label>
                        <Field
                             name='star_rating'
                             component={StarRating}
                             count={5}
                             type="text"
                        />
                    </FormGroup>
                    <FormGroup className="col-12 col-sm-4">
                        <Label>Slug</Label>
                        <Field
                             name='slug'
                             placeholder='Enter Ship Slug'
                             component={TextInput}
                             type='text'
                        />
                    </FormGroup>
                </div>
                <div class="row">
                    <FormGroup className="col-12">
                        <Label>Ship Summary</Label>
                        <Field
                            name='summary'
                            component={Wysiwyg}
                            placeholder='Summary'
                            className='form-control'
                            type='text'
                            validate={validations.required}
                        />
                    </FormGroup>
                    <FormGroup className="col-12">
                        <Label>Ship Images</Label>
                        <p className='instruction'>
                        Images must be 1920 x 1080 or bigger in the same aspect
                        ratio
                        </p>
                        <Field
                        name='banner_image'
                        component={FileUpload}
                        multiple={false}
                        files={false}
                        images={true}
                        type='text'
                        className='form-control'
                        validate={validations.required}
                        />
                    </FormGroup>
                </div>

                <div className="row">
                    <FormGroup className="col-12 col-sm-6">
                        <Label>Available Room Types</Label>
                        <Field
                            name="rooms"
                            component={CreatableSelect}
                            options={props.roomTypes}
                            type="text"
                            labelKey={"name"}
                            valueKey={"id"}
                            multi={true}
                            validate={validations.required}
                        />
                    </FormGroup>
        
                    <FormGroup className="col-12 col-sm-6">
                        <Label>Available Board Types</Label>
                        <Field
                            name="board_types"
                            component={CreatableSelect}
                            options={props.boardTypes}
                            type="text"
                            labelKey={"name"}
                            valueKey={"id"}
                            multi={true}
                            validate={validations.required}
                        />
                    </FormGroup>
                </div>
                <div class="row">
                    <FormGroup className="col-12 col-sm-6">
                        <Label>Ship Facilities</Label>
                        <Field
                            name="facilities"
                            component={CreatableSelect}
                            options={props.facilities}
                            type="text"
                            valueKey={"id"}
                            labelKey={"name"}
                            multi={true}
                            validate={validations.required}
                        />
                    </FormGroup>
                    <FormGroup className='col-12 col-sm-6'>
                      <Label>i-frame Content</Label>
                      <Field
                        name='iframe'
                        component={TextInput}
                        placeholder='i-frame content'
                        className='form-control'
                        type='text'
                      />
                    </FormGroup>
                    {this.props && this.props.formValues && this.props.formValues.iframe && (

                    <div style={{width:"100%"}} dangerouslySetInnerHTML={{__html: this.props.formValues.iframe}} />

                    )
                    }
                    
                </div>
            </section>
          {/* <Nav tabs>
            <NavItem>
              <NavLink
                className={this.state.activeTab === 1 ? 'active' : ''}
                onClick={() => this.toggleTab(1)}
              >
                Ship Details
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={this.state.activeTab === 3 ? 'active' : ''}
                onClick={() => this.toggleTab(3)}
              >
                Destination Guide
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={this.state.activeTab === 4 ? 'active' : ''}
                onClick={() => {
                  this.toggleTab(4);
                }}
              >
                Reviews
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={this.state.activeTab === 5 ? 'active' : ''}
                onClick={() => {
                  this.toggleTab(5);
                }}
              >
                Activities
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={this.state.activeTab === 6 ? 'active' : ''}
                onClick={() => {
                  this.toggleTab(6);
                }}
              >
                F&Q's
              </NavLink>
            </NavItem>
          </Nav> */}
          {/* <section className='form-section'>
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId={1}>
                <div className='row'>
                  <FormGroup className='col-12 col-sm-6'>
                    <Label htmlFor='email'>Ship Name</Label>
                    <Field
                      name='name'
                      placeholder='Enter Ship Name'
                      component={TextInput}
                      type='text'
                      validate={validations.required}
                    />
                  </FormGroup>

                  <FormGroup className='col-12 col-sm-6'>
                    <Label>Cruise Line Name</Label>
                    <Field
                      name='cruise_line'
                      component={SelectDropdown}
                      options={this.props.cruiseLines}
                      labelKey={'value'}
                      valueKey={'id'}
                      type='text'
                      multi={false}
                      className='form-control'
                      validate={validations.required}
                    />
                    <Modal
                      isOpen={this.state.cruiseLineToggle}
                      toggle={this.toggleCruiseLine}
                    >
                      <ModalBody>
                        <DealNewCruiseLineWrapper regions={regions} />
                      </ModalBody>
                    </Modal>
                  </FormGroup>
                </div>
                <div className='row'>
                  <FormGroup className='col-12'>
                    <Label>Sub Heading</Label>
                    <Field
                      name='subtitle'
                      placeholder='Sub Heading'
                      component={TextInput}
                      type='text'
                    />
                  </FormGroup>
                </div>
                <div className='row'>
                  <FormGroup className='col-12'>
                    <Label>Hero Image</Label>
                    <p className='instruction'>
                      Images must be 1920 x 1080 or bigger in the same aspect
                      ratio
                    </p>
                    <Field
                      name='banner_image'
                      component={FileUpload}
                      multiple={false}
                      files={false}
                      images={true}
                      type='text'
                      className='form-control'
                      validate={validations.required}
                    />
                  </FormGroup>
                </div>

                <div className='row'>
                  <FormGroup className='col-12'>
                    <Label>Top Description (Summary)</Label>
                    <Field
                      name='summary'
                      component={Wysiwyg}
                      placeholder='Summary'
                      className='form-control'
                      type='text'
                      validate={validations.required}
                    />
                  </FormGroup>
                </div>

                <div className='row'>
                  <FormGroup className='col-12'>
                    <Label>Top Description Cruise & Stay (Summary)</Label>
                    <Field
                      name='multi_center_summary'
                      component={Wysiwyg}
                      placeholder='Summary'
                      className='form-control'
                      type='text'
                    />
                  </FormGroup>
                </div>

                <div className='row'>
                  <FormGroup className='col-12'>
                    <Label>Description</Label>
                    <Field
                      name='description'
                      component={Wysiwyg}
                      placeholder='Summary'
                      className='form-control'
                      type='text'
                    />
                  </FormGroup>
                </div>

                <div className='row'>
                  <FormGroup className='col-12'>
                    <Label>Description Cruise & Stay </Label>
                    <Field
                      name='multi_center_description'
                      component={Wysiwyg}
                      placeholder='Summary'
                      className='form-control'
                      type='text'
                    />
                  </FormGroup>
                </div>

                <div className='row'>
                  <FormGroup className='col-12'>
                    <Label>i-frame Content</Label>
                    <Field
                      name='iframe'
                      component={TextInput}
                      placeholder='i-frame content'
                      className='form-control'
                      type='text'
                    />
                  </FormGroup>
                </div>

                <div className='row'>
                  <FormGroup className='col-12 col-sm-4' />
                </div>
              </TabPane>
              <TabPane tabId={2}>
                <div className='row'>
                  <FormGroup className='col-12 col-sm-6'>
                    <Label htmlFor='email'>Reorder Deals</Label>
                    <Field
                      name='deals'
                      component={List}
                      type='text'
                      itemsDisabled={true}
                    />
                  </FormGroup>
                </div>
              </TabPane>
              <TabPane tabId={3}>
                <div className='row'>
                  <FormGroup className='col-12'>
                    <Label>Guide</Label>
                    <Field name='guide' component={Wysiwyg} type='text' />
                  </FormGroup>
                </div>
              </TabPane>
              <TabPane tabId={4}>
                <ReviewsTable
                  data={this.props.reviews}
                  dispatch={this.props.dispatch}
                  formValues={this.props.formValues}
                  initialValues={this.props.initialValues}
                  formType='ShipForm'
                />
              </TabPane>
              <TabPane tabId={5}>
                <FieldArray name={'activities'} component={Activites} />
              </TabPane>
              <TabPane tabId={6}>
                <FieldArray name={'faqs'} component={Faq} />
              </TabPane>
            </TabContent>
          </section> */}
        </Form>

        {this.props.submitFailed && (
          <div className='error-container'>
            <Alert color='danger'>
              <strong>There are errors in your form.</strong>
              <br />
              Please check before submitting again.
            </Alert>
          </div>
        )}
      </section>
    );
  }
}

EditForm = reduxForm({
  form: 'ShipForm',
  onChange: (values, dispatch, props) => {
    if (props.error || props.submitFailed) {
      dispatch(stopSubmit('ShipForm'));
    }
  },
  destroyOnUnmount: false,
})(EditForm);

const mapStateToProps = (state) => {
  return {
    ships: state.overview.ships,
    reviews: state.overview.reviews,
    formValues: getFormValues('ShipForm')(state),
    facilities: state.overview.facilities,
    boardTypes: state.overview.boardTypes,
    roomTypes: state.overview.roomTypes,
  };
};

export default connect(mapStateToProps)(EditForm);



// WEBPACK FOOTER //
// ./src/containers/Ships/Form.jsx